import { TrackerEventType } from "src/core/model/TrackerEventType";
import { TrackerVariableType } from "src/core/model/TrackerVariableType";

import { EventListener } from "./EventListener";
import { NativeEventTrigger } from "./PageViewListener";

/**
 * Listens for scroll events (debounced + cooldown).
 * Uses debounce to wait for scroll to settle, then cooldown to prevent
 * excessive event triggering during continuous scrolling.
 */
export class ScrollListener implements EventListener {
  private trigger: NativeEventTrigger;
  private started = false;
  private boundHandler: (() => void) | null = null;
  private debounceTimer: ReturnType<typeof setTimeout> | null = null;
  private debounceMs: number;
  private cooldownMs: number;
  private lastTriggerTs = 0;

  constructor(trigger: NativeEventTrigger, debounceMs = 800, cooldownMs = 2000) {
    this.trigger = trigger;
    this.debounceMs = debounceMs;
    this.cooldownMs = cooldownMs;
  }

  start(): void {
    if (this.started) return;
    this.started = true;

    this.boundHandler = () => {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        const now = Date.now();
        if (now - this.lastTriggerTs >= this.cooldownMs) {
          this.lastTriggerTs = now;
          this.trigger(TrackerEventType.SCROLL);
        }
      }, this.debounceMs);
    };
    window.addEventListener("scroll", this.boundHandler, { passive: true });
  }

  stop(): void {
    if (!this.started) return;
    this.started = false;

    if (this.boundHandler) {
      window.removeEventListener("scroll", this.boundHandler);
      this.boundHandler = null;
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
  }

  getTypes(): TrackerEventType[] {
    return [TrackerEventType.SCROLL];
  }

  getVariableTypes(): TrackerVariableType[] {
    return [];
  }
}
